export default function rebox (element) {
  $(element).rebox({selector: 'figure a'})
}



// WEBPACK FOOTER //
// ./Private/Scripts/lib/rebox.js